import CommonModal from 'components/common/CommonModal';
import DefaultButton from 'components/common/DefaultButton';
import DefaultImageView from 'components/common/DefaultImageView';
import DefaultText from 'components/common/DefaultText';
import {getUserPermissions} from 'function/api';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import {colors} from 'styles/colors';
import {IUserInfo} from 'utils/Atoms';
import {minmax} from 'utils/minmax';

/**
 * 역할 목록 컴포넌트의 Props 타입
 * @property {() => void} closeModal - 모달 닫기 함수
 */
type Props = {
  selectWorker: any;
  closeModal: () => void;
  defaultProps: {
    userInfo: IUserInfo | null;
    setErrorModal: React.Dispatch<React.SetStateAction<{}>>;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  };
};

export const RoleList = ({selectWorker, closeModal, defaultProps}: Props) => {
  const navigate = useNavigate();

  const [data, setData] = useState<any>();

  useEffect(() => {
    getUserPermissions({
      ...defaultProps,
      userUUID: selectWorker?.user?.uuid,
    }).then(result => {
      console.log(result?.list);
      setData(result?.list);
    });
  }, []);

  return (
    <CommonModal closeModal={closeModal}>
      <Container>
        <Header>
          <DefaultText
            text="권한 목록"
            textStyle={{
              width: '100%',
              fontSize: minmax(30),
              fontWeight: 'bold',
            }}
          />
          <DefaultImageView
            source="images/common/close.png"
            onClick={closeModal}
            style={{
              width: minmax(30),
              cursor: 'pointer',
            }}
          />
        </Header>

        <div style={{display: 'flex', justifyContent: 'end', width: '100%'}}>
          <DefaultButton
            text={'권한 변경하러가기'}
            buttonStyle={{
              height: 'fit-content',
              padding: minmax(20),
              marginBottom: minmax(30),
              backgroundColor: colors.primary2,
            }}
            textStyle={{color: colors.white}}
            onClick={() => {
              navigate('/userManagementUserDetail', {
                state: {uuid: selectWorker.userUUID, info: selectWorker},
              });
            }}
          />
        </div>

        <ResultHeader>
          <DefaultText
            text="permission"
            textStyle={{...ResultHeaderTextStyle}}
          />
          <DefaultText
            text="permissionType"
            textStyle={{...ResultHeaderTextStyle}}
          />
          <DefaultText
            text="acquisitionStatus"
            textStyle={ResultHeaderTextStyle}
          />
        </ResultHeader>

        <RoleListWrap>
          {data &&
            data?.map((role: any) => (
              <div
                key={role}
                style={{
                  display: 'flex',
                  borderBottom: '1px solid ' + colors.borderGray,
                  minHeight: minmax(60),
                  alignItems: 'center',
                }}>
                <DefaultText
                  text={role.role}
                  textStyle={{
                    ...ResultItemStyle,
                  }}
                />
                <DefaultText
                  text={role.permissionProfileType}
                  textStyle={{
                    ...ResultItemStyle,
                  }}
                />
                <DefaultText
                  text={role.role ? 'contractor' + role.role : '-'}
                  textStyle={{
                    ...ResultItemStyle,
                  }}
                />
              </div>
            ))}
        </RoleListWrap>
      </Container>
    </CommonModal>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${minmax(25)};
`;

const RoleListWrap = styled.div`
  width: 100%;
  max-height: ${minmax(400)};
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 2,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 2,
  textAlign: 'center',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  wordBreak: 'break-all',
};
